<template>
  <div>
    <multiple-choice></multiple-choice>
    <email></email>
    <redirect></redirect>
    <text-step></text-step>
    <welcome></welcome>
  </div>
</template>

<script>
import MultipleChoice from './MultipleChoice.vue';
import Email from './Email.vue';
import Redirect from './Redirect.vue';
import TextStep from './Text.vue';
import Welcome from './Welcome.vue';

export default {
  components: {
    MultipleChoice,
    Email,
    Redirect,
    TextStep,
    Welcome,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?d20cb034
 **/